import React, { useReducer } from 'react'
import { initialState, publishSchedule as reducer } from '../../reducers/publishSchedule'
import { PublishScheduleStateContext, PublishScheduleDispatchContext } from './context'

export const PublishScheduleProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <PublishScheduleStateContext.Provider value={state}>
      <PublishScheduleDispatchContext.Provider value={dispatch}>
        {children}
      </PublishScheduleDispatchContext.Provider>
    </PublishScheduleStateContext.Provider>
  )
}
